<template>
  <div class="_taskView__steps__step" v-if="!isHidden || isVisible">
    <md-checkbox 
      v-model="isComplete"
      :disabled="isBusy || isRefreshing || isDisabled"
      @change="onToggle"
    >{{ step.title }}</md-checkbox>
  </div>
</template>

<script>
import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
import * as mutations from '@/graphql/mutations';

export default {
  props: {
    step: {
      type: Object,
      required: true,
    },
    isCompleteInOrder: {
      type: Boolean,
      required: false,
    },
    atStepUpdate: {
      type: Function,
      required: true
    },
    isRefreshing: {
      type: Boolean,
      required: false,
    },
    isVisible: {
      type: Boolean,
      required: false,
    }
  },
  data() {
    return {
      isBusy: false,
      isComplete: false,
    };
  },
  computed: {
    isDisabled() {
      if (this.isCompleteInOrder && !this.step.isAvailable) {
        return true;
      }
      if ('complete' == this.step.status.toLowerCase()) {
        return true;
      }
      return false;
    },
    isHidden() {
      if (!this.isCompleteInOrder || ('complete' == this.step.status.toLowerCase())) {
        return false;
      }
      return !this.step.isAvailable;
    }
  },
  methods: {
    onToggle() {
      this.isBusy = true;
      this.$emit('busy');
      const operation = graphqlOperation(mutations.updateTaskStep, this.getUpdatePayload());
      API.graphql(operation)
        .then(response => {
          console.log('Task Step Updte Success - ', response);
          this.atStepUpdate(response.data.updateTaskStep);
          this.isBusy = false;
          this.$emit('free');
        })
        .catch(err => {
          this.isBusy = false;
          console.log('Task Step Updte Error - ', err);
          this.$emit('free');
        });
    },
    getUpdatePayload() {
      const status = this.isComplete ? 'Complete' : 'Open';
      let isAvailable = true;
      if (this.isCompleteInOrder && 'Complete' == status) {
        isAvailable = false;
      }
      return {
        input: {
          id: this.step.id,
          status,
          isAvailable
        }
      };
    }
  },
  watch: {
    'step.status': {
      immediate: true,
      handler: function() {
        let status = this.$reduce(this, 'step.status');
        if (status) {
          status = status.toLowerCase();
        }
        this.isComplete = 'complete' == status ? true : false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
